/**
 * Created by Darius on 2017.02.18.
 */
import {createLogger} from "redux-logger";
import {applyMiddleware, createStore} from "redux";
import {localStorageMiddleware, promiseMiddleware} from "../middleware";
import reducer from "../reducer";

const loggerMiddleware = createLogger();

const middleware = applyMiddleware(promiseMiddleware, localStorageMiddleware, loggerMiddleware);

const store = createStore(reducer, middleware);

export default store;